import { useTranslation, useFormatting } from '../../i18n/i18n';
import { Loader } from '../Loader/Loader';
import { UiContainer } from '../../state/ui';
import { Table } from '../Table/Table';
import { ApiCart } from '../../types';
import { useDefaultVatMultiplier } from '../../utils/vatUtils';

type CartTotalsTableProps = { cart: ApiCart; showLetterFee?: boolean };

export const CartTotalsTable = ({ cart, showLetterFee }: CartTotalsTableProps) => {
	const t = useTranslation().cart;
	const totals = cart.totals;
	const { asPrice } = useFormatting();
	const ui = UiContainer.useContainer();
	const vatMultiplier = useDefaultVatMultiplier(ui.priceWithVat);

	if (!totals)
		return (
			<div id="cart">
				<Loader />
			</div>
		);
	const { subTotal, subTotalVat, shippingFee, discount, vat, total } = totals;

	if (cart.items.length === 0) return null;

	return (
		<div id="cart-totals">
			<Table>
				<tbody>
					<tr>
						<td>{t.subTotal}</td>
						<td className="text-right">
							{asPrice(subTotal + (ui.priceWithVat ? subTotalVat : 0), 2, false)}
						</td>
					</tr>
					<tr>
						<td>{t.delivery}</td>
						<td className="text-right">{asPrice(shippingFee * vatMultiplier, 2, false)}</td>
					</tr>
					{totals.discount < 0 && (
						<tr className="discount-code">
							<td>{totals.discountTitle}</td>
							<td className="text-right">{asPrice(discount, 2, false)}</td>
						</tr>
					)}
					{totals.notificationFee > 0 && (
						<tr>
							<td>{t.notificationFee}</td>
							<td className="text-right">{asPrice(totals.notificationFee, 2, false)}</td>
						</tr>
					)}
					{showLetterFee && totals.letterFee > 0 && (
						<tr>
							<td>{t.letterFee}</td>
							<td className="text-right">{asPrice(totals.letterFee, 2, false)}</td>
						</tr>
					)}
					{!ui.priceWithVat && (
						<tr>
							<td>{t.vat}</td>
							<td className="text-right">{asPrice(vat)}</td>
						</tr>
					)}
					<tr className="big">
						<td>
							<span>{t.totalIncVatHeading}</span>
						</td>
						<td className="text-right">
							<span>{asPrice(total)}</span>
						</td>
					</tr>
				</tbody>
			</Table>
		</div>
	);
};
